import apiClient from './client';

export interface License {
  id: string;
  key: string;
  status: string;
  issuedAt: string;
  expiresAt: string;
}

export interface LicenseStats {
  licenses: {
    total: number;
    active: number;
    inactive: number;
  };
  devices: {
    total: number;
    active: number;
    inactive: number;
  };
  applications: {
    total: number;
  };
}

export const getLicenses = async (): Promise<License[]> => {
  const response = await apiClient.get<License[]>('/licenses');
  return response.data;
};

export const getLicenseStats = async (): Promise<LicenseStats> => {
  const response = await apiClient.get<LicenseStats>('/api/stats');
  return response.data;
};

export const createLicense = async (data: { expiresAt: string }): Promise<License> => {
  const response = await apiClient.post<License>('/licenses', data);
  return response.data;
};

export const revokeLicense = async (id: string): Promise<void> => {
  await apiClient.post(`/licenses/${id}/revoke`);
};

export const activateLicense = async (id: string): Promise<void> => {
  await apiClient.post(`/licenses/${id}/activate`);
};

export const updateLicense = async (id: string, updates: { expiresAt?: string }): Promise<License> => {
  const response = await apiClient.put<License>(`/licenses/${id}`, updates);
  return response.data;
};

export const deleteLicense = async (id: string): Promise<void> => {
  await apiClient.delete(`/licenses/${id}`);
}; 